import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDoubleCheckmark2Small"><Path d="M4.5 13L7.5 16L14.5 8" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 16L19.5 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDoubleCheckmark2Small;
